import ProfileIncidentsStore from "./Store/ProfileIncidentsStore"

export default {
    namespaced: true,
    modules: {
        incidents: ProfileIncidentsStore,
    }
}
